export const EMPLOYEE_TYPES = {
  ADMINISTRATION: "administration"
}
